import React from "react";
import { Link } from 'react-router-dom';
import Footer from "../ui/Footer";
import Logo from '../../components/assets/logo/logo';
import './logs.css'

const signup = () =>{
        return (
            <div>
            <Link to={"/"}><Logo/></Link>
            <form>
                <h1>Sign Up</h1>

                <div className="input-container">
                    <label>First name</label>
                    <input type="text" className="form-control" placeholder="First name" />
                </div>

                <div className="input-container">
                    <label>Last name</label>
                    <input type="text" className="form-control" placeholder="Last name" />
                </div>

                <div className="input-container">
                    <label>Email address</label>
                    <input type="email" className="form-control" placeholder="Enter email" />
                </div>

                <div className="input-container">
                    <label>Password</label>
                    <input type="password" className="form-control" placeholder="Enter password" />
                </div>

                <button type="submit" className="submit">Sign Up</button>
                <p className="input-container">Already registered &nbsp;<Link to="/sign-in">Sign in?</Link></p>
                
            </form>

            <Footer />

            </div>
        );
}


export default signup;